import classNames from 'classnames';
import { DetailedHTMLProps, FunctionComponent, HTMLAttributes } from 'react';
import styles from './styles.module.scss';

export type BoxProps = {
    variant?: 'default' | 'tinted' | 'darker';
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Box: FunctionComponent<BoxProps> = ({ variant = 'default', className, ...props }) => {
    return <div className={classNames(styles.box, className, styles[variant])} {...props} />;
};
